'use client'

import { useContext, useState } from 'react'

import { toast } from 'react-toastify'
import { cn, Spinner } from '@nextui-org/react'

import useUploadImage from '@/hooks/useUploadImage'
import { useEditPostMutation, useUpPostsMutation } from '@/redux/api/post-cre/post.w3'
import { useAppSelector } from '@/hooks'
import { editPostParams, postTypeCre } from '@/redux/api/post-cre/post.type'

import { PostContext, TextareaPost, TextareaPostProvider } from '../TextareaPostProvider'

export const ImplementPostProvider = ({ onTonggleModal }: { onTonggleModal?: (v: any) => void }) => {
  const [upPosts, { isLoading }] = useUpPostsMutation()
  const [editPost, { isLoading: isLoadingEdit }] = useEditPostMutation()
  const [postLoading, setPostLoading] = useState(false) // Add loading state
  const { loading, handleUploadImage } = useUploadImage()
  const spaceActive = useAppSelector((state) => state.root.settings.spaceActive)

  const { images, textPost, setImages, setMetadata, setTextPost, setIscompleted, postId } =
    useContext(PostContext) || {}

  const handlePost = async () => {
    if (textPost === '' && images.length === 0) {
      return
    }
    setPostLoading(true)
    try {
      let post
      if (postId) {
        const links = images.filter((item: any) => typeof item === 'string')
        const files = images.filter((item: any) => item instanceof File)

        let listIMG: string[] = []
        if (files.length) {
          listIMG = await handleUploadImage(files)
        }

        post = {
          id: postId,
          content: textPost,
          imageUrls: [...listIMG, ...links],
          isPublic: true,
        } as editPostParams

        if (spaceActive) {
          post.spaceId = spaceActive
        }

        const editPostRes = await editPost(post).unwrap()
        if (editPostRes?.statusCode === 500) {
          throw new Error()
        }

        setTextPost('')
        setImages([])
        setMetadata(null)
        onTonggleModal?.(editPostRes)
        toast.success('Update post successfully!')
      } else {
        let listIMG: string[] = []
        if (images.length) {
          listIMG = await handleUploadImage(images)
        }

        post = {
          content: textPost,
          imageUrls: listIMG,
          isPublic: true,
        } as postTypeCre
        if (spaceActive) {
          post.spaceId = spaceActive
        }
        const postRes = await upPosts(post).unwrap()

        if (postRes?.statusCode === 500) {
          if (postRes.message) {
            toast.error(postRes.message)
            return
          }
          throw new Error()
        }

        setTextPost('')
        setImages([])
        setMetadata(null)
        onTonggleModal?.(postRes)
      }
    } catch (err: any) {
      {
        postId
          ? toast.error('Update post failed, please try again!')
          : toast.error(err?.data?.error || 'Create post failed, please try again!')
      }
    } finally {
      setPostLoading(false)
      setIscompleted(true)
    }
  }

  return (
    <button
      onClick={handlePost}
      disabled={postLoading || loading}
      className={cn(
        textPost || images.length > 0 ? 'ss-btn' : 'ss-btn-disable',
        'flex items-center gap-1 px-3 py-2 text-xs font-medium',
      )}
    >
      {(loading || (postId ? isLoadingEdit : isLoading)) && <Spinner size="sm" />} {postId ? 'Update' : 'Post'}
    </button>
  )
}

const PostTextarea = () => {
  return (
    <TextareaPostProvider>
      <TextareaPost type="post">
        <ImplementPostProvider />
      </TextareaPost>
    </TextareaPostProvider>
  )
}

export default PostTextarea
